module.exports = __webpack_public_path__ + "static/media/service-3_old.d026ccd3.jpg";